import getStorageUser from "../middlewares/GetStorageUser"


export const useUser = () => {
    // const [user, setUser] = useState<any>({});

    const getUser = async () => {
        try {
            const user = getStorageUser()
        return user;
        // setUser(user)
        } catch (error) {
            console.log(error);
        }
    }


    // useEffect(() => {
    //     const token = localStorage.getItem('token')
    //     if (token) {
    //         getUser()
    //     }
    // }, []);


    return {
        // user
        getUser,
    }

}
